import React, { useEffect } from "react";
import { Col, Row, Typography } from "antd";
import { useQuery } from "react-query";
import ProductDetail from "@components/ProductDetail";
import Information from "@components/Information";
import { getUpNextProduct } from "dataLayer/product";
import EmptyData from "@components/EmptyData";
import { useTranslation } from "react-i18next";

import './index.scss';

const { Title } = Typography;
const UpNextPage = () => {
  const { data: products } = useQuery(getUpNextProduct());
  const { t } = useTranslation();
  useEffect(() => {
    document.title = t("title.upcomming");
  }, [t]);
  return (
    <div className="up-next-page">
      <div className="up-next-page-wrapper">
        <Title level={2} className="up-next-page-title">
          {t("upcomming")}
        </Title>
        <Row gutter={[0, 35]}>
          {products?.map((product, idx) => (
            <Col xs={24} key={`product_${idx}`}>
              <ProductDetail
                product={product}
                isUpcoming={true}
                isPotentialWinner={false}
              />
              <Information product={product} />
            </Col>
          ))}
        </Row>
        {products?.length === 0 && <EmptyData message={t("no_next_round")} />}
      </div>
    </div>
  );
};

export default UpNextPage;
